// FETCH ALL PART_MASTER
export const FETCH_PART_MASTER_REQUEST = 'FETCH_PART_MASTER_REQUEST';
export const FETCH_PART_MASTER_SUCCESS = 'FETCH_PART_MASTER_SUCCESS';
export const FETCH_PART_MASTER_FAILURE = 'FETCH_PART_MASTER_FAILURE';

// CREATE PART_MASTER
export const CREATE_PART_MASTER_REQUEST = 'CREATE_PART_MASTER_REQUEST';
export const CREATE_PART_MASTER_SUCCESS = 'CREATE_PART_MASTER_SUCCESS';
export const CREATE_PART_MASTER_FAILURE = 'CREATE_PART_MASTER_FAILURE';

// FETCH SINGLE PART DATA
export const FETCH_SINGLE_PART_MASTER_REQUEST = 'FETCH_SINGLE_PART_MASTER_REQUEST';
export const FETCH_SINGLE_PART_MASTER_SUCCESS = 'FETCH_SINGLE_PART_MASTER_SUCCESS';
export const FETCH_SINGLE_PART_MASTER_FAILURE = 'FETCH_SINGLE_PART_MASTER_FAILURE';

// UPDATE PART_MASTER
export const UPDATE_PART_MASTER_REQUEST = 'UPDATE_PART_MASTER_REQUEST';
export const UPDATE_PART_MASTER_SUCCESS = 'UPDATE_PART_MASTER_SUCCESS';
export const UPDATE_PART_MASTER_FAILURE = 'UPDATE_PART_MASTER_FAILURE';

// DELETE PART_MASTER
export const DELETE_PART_MASTER_REQUEST = 'DELETE_PART_MASTER_REQUEST';
export const DELETE_PART_MASTER_SUCCESS = 'DELETE_PART_MASTER_SUCCESS';
export const DELETE_PART_MASTER_FAILURE = 'DELETE_PART_MASTER_FAILURE';

// FETCH ALL PART_MASTER BY STYLE DETAIL ID
export const FETCH_PART_MASTER_BY_STYLE_DETAIL_ID_REQUEST = 'FETCH_PART_MASTER_BY_STYLE_DETAIL_ID_REQUEST';
export const FETCH_PART_MASTER_BY_STYLE_DETAIL_ID_SUCCESS = 'FETCH_PART_MASTER_BY_STYLE_DETAIL_ID_SUCCESS';
export const FETCH_PART_MASTER_BY_STYLE_DETAIL_ID_FAILURE = 'FETCH_PART_MASTER_BY_STYLE_DETAIL_ID_FAILURE';

export const FETCH_PRINTING_TYPE_REQUEST = 'FETCH_PRINTING_TYPE_REQUEST';
export const FETCH_PRINTING_TYPE_SUCCESS = 'FETCH_PRINTING_TYPE_SUCCESS';
export const FETCH_PRINTING_TYPE_FAILURE = 'FETCH_PRINTING_TYPE_FAILURE';

export const RESET_PART_MASTER_INFO = 'RESET_PART_MASTER_INFO';

export const CREATE_PART_MASTER_FORM = 'CREATE_PART_MASTER_FORM';

export const UPDATE_PART_MASTER_FORM = 'UPDATE_PART_MASTER_FORM';

export const PARTY_MASTER_SET_ACTIVE_REQUEST = 'PARTY_MASTER_SET_ACTIVE_REQUEST';
export const PARTY_MASTER_SET_ACTIVE_SUCCESS = 'PARTY_MASTER_SET_ACTIVE_SUCCESS';
export const PARTY_MASTER_SET_ACTIVE_FAILURE = 'PARTY_MASTER_SET_ACTIVE_FAILURE';


export const FETCH_PARTY_MASTER_REQUEST = 'FETCH_PARTY_MASTER_REQUEST';
export const FETCH_PARTY_MASTER_SUCCESS = 'FETCH_PARTY_MASTER_SUCCESS';
export const FETCH_PARTY_MASTER_FAILURE = 'FETCH_PARTY_MASTER_FAILURE';